import styled from "styled-components";

const H3 = styled.h3`
  font-size: 2.5rem;
  letter-spacing: 0px;
  line-height: 1;
`

export default H3